/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDistanceProfile.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/distance-profile";

export class AutogenModelDistanceProfile<RowType extends ModelRow> extends Endpoint<RowType, RowDistanceProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDistanceProfile extends ModelRow<RowDistanceProfileFields> {
	constructor(values?: Partial<RowDistanceProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDistanceProfileFields {
	alk_53ft_trailer: string;
	alk_borders_open: string;
	alk_custom_roads: string;
	alk_hazmat: string;
	alk_hwy_only: string;
	alk_national_net: string;
	alk_ovrd_restrict: string;
	alk_tolls_disc: string;
	company_id: string;
	description: string;
	id: string;
	local_override: string;
	lookup_type: string;
	method: string;
	mm_border_crossings: string;
	mm_borders_open: string;
	mm_depart_option: string;
	mm_departure_time: Date;
	mm_ferries: string;
	mm_fuel_economy: number;
	mm_fuel_price: number;
	mm_governor_speed: number;
	mm_hazmat_route: string;
	mm_hazmat_types: string;
	mm_height_ft: number;
	mm_height_in: number;
	mm_highways: string;
	mm_historical_traffic: string;
	mm_labor_cost: number;
	mm_maintenance_cost: number;
	mm_number_axels: number;
	mm_optimization: number;
	mm_preffered_avoid: string;
	mm_toll_road_bias: number;
	mm_tolls: string;
	mm_trailer_option: string;
	mm_trailer_option_19: string;
	mm_tunnels: string;
	mm_unpaved_roads: string;
	mm_uturn: string;
	mm_vehicle_axle_count: number;
	mm_vehicle_height: number;
	mm_vehicle_lenght: number;
	mm_vehicle_type: string;
	mm_vehicle_weight: number;
	mm_width_ft: number;
	mm_width_in: number;
	payusing: string;
	pms_avoid_tolls: string;
	pms_borders_open: string;
	profile_lookup_type: string;
	profile_method: string;
	profile_server: string;
	profile_version: string;
	rm_102_width: string;
	rm_app_roadwk: string;
	rm_avg_fuel_cost: number;
	rm_avg_fuel_eff: number;
	rm_can_border: string;
	rm_cost_per_hour: number;
	rm_default_zip: string;
	rm_hazmat: string;
	rm_maint_cost: number;
	rm_phys_restr: string;
	rm_rte_delays: string;
	rm_seg_override: string;
	rm_toll_bias: number;
	rm_toll_override: string;
	rm_trailer_ln: string;
	rm_truck_type: string;
	source: string;
	version: string;
}

